import { PersonSearchOutlined } from '@mui/icons-material';
import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { isMaxNumberOfUsersReached } from 'utils/VisitorGroup/VisitorGroup';
import useDrawerContext from 'v2/components/Drawer/useDrawerContext';
import EmptyStateOverview from 'v2/components/EmptyStateOverview/EmptyStateOverview';
import AddUserToGroupDrawer from 'v2/pages/Users/Groups/Details/components/AddUserToGroupDrawer';

interface Props {
  visitorGroup: VisitorGroup;
  isAddVisitorButtonVisible: boolean;
}

const EmptyUsersTab: React.FC<Props> = ({ visitorGroup, isAddVisitorButtonVisible }) => {
  const { translation } = useTranslation();
  const { openDrawer } = useDrawerContext();

  const isMaxNumberOfUsersReachedCheck = isMaxNumberOfUsersReached(visitorGroup);

  const handleOpenAddUserDrawer = () => {
    openDrawer(
      <AddUserToGroupDrawer
        preSelectedGroup={{ label: visitorGroup.name, value: visitorGroup.id }}
        hideGroupField
        isMaxNumberOfUsersReached={isMaxNumberOfUsersReachedCheck}
      />
    );
  };

  return (
    <EmptyStateOverview
      icon={PersonSearchOutlined}
      title={translation.no_users_in_group}
      content={translation.let_s_get_started_by_adding_your_first_user}
      button={isAddVisitorButtonVisible ? { label: translation.add_user, onClick: handleOpenAddUserDrawer } : undefined}
      sx={{ height: 'auto', pt: 8, pb: 4 }}
    />
  );
};

export default EmptyUsersTab;
